<template>
  <RevButton
    :disabled
    :loading
    :to
    variant="primary"
    @click.capture="onButtonClick"
  >
    {{ i18n(translations.buttonCheckout) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './CheckoutButton.translations'

const i18n = useI18n()
const injectLocale = useRouteLocationWithLocale()

defineProps<{
  loading: boolean
  disabled: boolean
}>()

const emit = defineEmits(['next'])

const to = computed(() =>
  injectLocale({
    name: CHECKOUT.ADDRESSES,
  }),
)

function onButtonClick(event: Event) {
  // click.prevent is not working on internal links - click.capture was proposed as an alternative by the DS
  // https://imperatorz.slack.com/archives/CFMDV68KA/p1765962408200679
  event.preventDefault()
  event.stopImmediatePropagation()

  emit('next')
}
</script>
